import userHttp from "services/axios.services/instances/userHttp";

export type TxnStatus = "SUCCESS" | "ERROR" | "PENDING" | string;

export interface TransactionApiItem {
  bbpsBillPaymentId: string;
  orderId: string;
  userId: string;
  refId: string;
  billerId: string;
  amount: number;
  isQuickPay: boolean;
  status: TxnStatus;

  responseCode: string | null;
  responseReason: string | null;
  approvalRefNum: string | null;
  transactionId: string | null;
  txnReferenceId: string | null;
  billerReferenceNumber: string | null;
  message: string | null;

  isDeleted: boolean;
  isLocked: boolean;

  createdAt: string;
  updatedAt: string;
}

export interface TransactionPageData {
  transactions: TransactionApiItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface TransactionPageResponse {
  data: TransactionPageData;
  status: boolean;
  statusCode: number;
  message: string;
  errors: any;
}

const UserTransactionService = {
  getUserTransactions: async (params: {
    pageNumber?: number;
    pageSize?: number;
  }): Promise<TransactionPageResponse> => {
    const { pageNumber = 1, pageSize = 10 } = params;

    const res: TransactionPageResponse = await userHttp.get(
      `/api/v1/transaction`,
      {
        params: { PageNumber: pageNumber, PageSize: pageSize },
      },
    );

    return res as TransactionPageResponse;
  },
};

export default UserTransactionService;

// import userHttp from "services/axios.services/instances/userHttp";

// export type TxnStatus = "SUCCESS" | "ERROR" | "PENDING" | string;

// export interface TransactionApiItem {
//   bbpsBillPaymentId: string;
//   orderId: string;
//   userId: string;
//   refId: string;
//   billerId: string;
//   amount: number;
//   isQuickPay: boolean;
//   status: TxnStatus;

//   responseCode: string | null;
//   responseReason: string | null;
//   approvalRefNum: string | null;
//   transactionId: string | null;
//   txnReferenceId: string | null;
//   billerReferenceNumber: string | null;
//   message: string | null;

//   isDeleted: boolean;
//   isLocked: boolean;

//   createdAt: string; // "2025-12-21T17:24:04"
//   updatedAt: string;
// }

// export interface TransactionPageData {
//   transactions: TransactionApiItem[];
//   pageNumber: number;
//   pageSize: number;
//   totalCount: number;
//   totalPages: number;
//   hasNext: boolean;
//   hasPrev: boolean;
// }

// export interface TransactionPageResponse {
//   data: TransactionPageData;
//   status: boolean;
//   statusCode: number;
//   message: string;
//   errors: any;
// }

// const UserTransactionService = {
//   getUserTransactions: async (params: {
//     pageNumber?: number;
//     pageSize?: number;
//   }): Promise<TransactionPageResponse> => {
//     const { pageNumber = 1, pageSize = 10 } = params;

//     const res = await userHttp.get(`/api/v1/transaction`, {
//       params: { PageNumber: pageNumber, PageSize: pageSize },
//     });

//     return res.data as TransactionPageResponse;
//   },
// };

// export default UserTransactionService;
